var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.FitHalfScreenDialog,{staticClass:"scan-gift-merchants",attrs:{"appendToBody":true,"title":_vm.info.title,"visible":_vm.visible},on:{"onClose":_setup.handleClose}},[_c('div',{staticClass:"content"},[(_vm.info.content)?_c('img',{attrs:{"src":_vm.info.content}}):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }